export enum SoundEnum {
    beep
}